import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WoundService } from 'app/core/services/wound/wound.service';
import { GetWoundByIdResponse } from 'app/core/models/wound/wound.model';
import { BaseApiResponse } from 'app/core/models/api/api.model';
import { WoundAssessmentDetailComponent } from '../wound-assessment-detail/wound-assessment-detail.component';

@Component({
  selector: 'app-scales-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, WoundAssessmentDetailComponent],
  templateUrl: './scales-modal.component.html',
  styleUrls: ['./scales-modal.component.scss'],
})
export class ScalesModalComponent implements OnInit {
  @Input() woundId: string = '';
  @Input() patientId: string = ''; // Optional, might not be needed for just showing assessment

  wound: GetWoundByIdResponse | null = null;
  isLoading = true;
  hasError = false;

  constructor(
    public activeModal: NgbActiveModal,
    private woundService: WoundService
  ) {}

  ngOnInit(): void {
    if (this.woundId) {
      this.loadWoundData();
    } else {
      this.hasError = true;
      this.isLoading = false;
    }
  }

  private loadWoundData(): void {
    this.isLoading = true;
    this.woundService.getWoundById(this.woundId).subscribe({
      next: (data: BaseApiResponse<GetWoundByIdResponse>) => {
        this.wound = data.data;
        this.isLoading = false;
      },
      error: () => {
        this.hasError = true;
        this.isLoading = false;
      },
    });
  }

  close(): void {
    this.activeModal.close();
  }
}
